import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import MediaService from '../../../utils/DeviationMediaService';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import s from './Commission.scss';
function getCoverImageFile(deviation, showMatureContent) {
    const { commission } = deviation;
    let coverImage = deviation.coverImage;
    if (!coverImage) {
        if (commission) {
            if (commission.examples && commission.examples.length) {
                coverImage = commission.examples[0];
            }
        }
    }
    if (coverImage && coverImage.isMature && !showMatureContent) {
        return null;
    }
    return coverImage && MediaService.getLargestFullview(coverImage);
}
export const CommissionStageBackground = ({ deviation })=>{
    const showMatureContent = useContext(MatureContext);
    const isMobile = useContext(MobileContext);
    const coverImage = getCoverImageFile(deviation, showMatureContent);
    if (!coverImage) {
        return /*#__PURE__*/ React.createElement(EmptyBackground, {
            className: s['empty-background']
        });
    }
    const { src } = coverImage;
    return /*#__PURE__*/ React.createElement(BackgroundImage, {
        src: src,
        fade: isMobile ? false : 'full-strong',
        subtleBlur: !isMobile
    });
};
CommissionStageBackground.displayName = 'CommissionStageBackground';
export default CommissionStageBackground;

//# sourceMappingURL=Commission.js.map